import { IFormViewForm } from 'components/FormView';

const PickSlipLineDetailsForm: IFormViewForm = {
  id: 'PickSlipLineDetailsForm',
  layout: {
    rows: 1,
    columns: 2
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        label: '',
        fullWidth: true
      },
      children: [
        {
          id: '0',
          type: 'TEXT_FIELD',
          props: {
            label: 'Description',
            name: 'Description',
            placeholder: '',
            size: 'large',
            required: false,
            inputProps: {
              maxLength: 40
            }
          }
        },
        {
          id: '1',
          type: 'EXTENDED_TEXT_FIELD',
          props: {
            label: 'Ordered',
            name: 'OrderedQuantity',
            placeholder: '',
            size: 'medium',
            required: false,
            decimalSeparator: true,
            alignment: 'right',
          }
        },
        {
          id: '2',
          type: 'TEXT_FIELD',
          props: {
            label: 'Supplied',
            name: 'SuppliedQuantity',
            placeholder: '',
            size: 'medium',
            required: false,
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 2
          }
        },
        {
          id: '3',
          type: 'TEXT_FIELD',
          props: {
            label: 'Kitting',
            name: 'KittingQuantity',
            placeholder: '',
            size: 'medium',
            required: false,
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 2
          }
        },
        {
          id: '4',
          type: 'TEXT_FIELD',
          props: {
            label: 'Backordered',
            name: 'BackOrderedQuantity',
            placeholder: '',
            size: 'medium',
            required: false,
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 2
          }
        },
        {
          id: '5',
          type: 'EXTENDED_TEXT_FIELD',
          props: {
            label: 'Price',
            name: 'Price',
            placeholder: '',
            size: 'medium',
            required: false,
            decimalSeparator: true,
            alignment: 'right'
          }
        },
        {
          id: '6',
          type: 'EXTENDED_DISPLAY_FIELD',
          visible: true,
          props: {
            label: 'Discount',
            name: 'Discount',
            size: 'small',
            type: 'number',
            decimalSeparator: true,
            adornment: '%',
          }
        },
        {
          id: '7',
          type: 'TEXT_FIELD',
          props: {
            label: 'Exchange deposit',
            name: 'ExchangeDeposit',
            placeholder: '',
            size: 'medium',
            required: false,
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 2
          }
        },
        {
          id: '8',
          type: 'TOGGLE_FIELD',
          visible: true,
          props: {
            label: 'Tax included price',
            name: 'TaxIncludedPrice'
          }
        },
        {
          id: '9',
          type: 'TOGGLE_FIELD',
          visible: true,
          props: {
            label: 'Special price',
            name: 'SpecialPrice'
          }
        },
        {
          id: '10',
          type: 'TOGGLE_FIELD',
          visible: true,
          props: {
            label: 'Fixed price',
            name: 'FixedPrice',
          }
        },
      ]
    },
    {
      id: 1,
      position: {
        row: 1,
        col: 2
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [
        {
          id: 0,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Quoted currency',
            size: 'small',
            name: 'QuoteCurrency',
            lookupName: 'CurrencyCode',
          }
        },
        {
          id: 1,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Quoted exchange rate',
            name: 'QuotedExchangeRate',
            size: 'medium',
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 10,
          }
        },
        {
          id: 2,
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Invoice exchange rate',
            name: 'InvoiceExchangeRate',
            size: 'medium',
            decimalSeparator: true,
            alignment: 'right',
            decimalPlaces: 10,
          }
        },
        {
          id: 3,
          type: 'DATE_FIELD',
          props: {
            label: 'Required ship',
            name: 'RequiredShipDate',
            dateFormat: 'DD/MM/YYYY',
            placeholder: 'DD/MM/YYYY',
            size: 'small',
          }
        },
        {
          id: 4,
          type: 'DATE_FIELD',
          props: {
            label: 'Expected ship',
            name: 'ExpectedShipDate',
            dateFormat: 'DD/MM/YYYY',
            placeholder: 'DD/MM/YYYY',
            size: 'small'
          }
        },
        {
          id: 5,
          type: 'DATE_FIELD',
          props: {
            label: 'Expiry',
            name: 'ExpiryDate',
            dateFormat: 'DD/MM/YYYY',
            placeholder: 'DD/MM/YYYY',
            size: 'small'
          }
        },
        {
          id: 6,
          type: 'TEXT_AREA',
          props: {
            label: 'Comment',
            name: 'Comment',
            size: 'large',
            style: {
              height: '300px',
            }
          }
        }
      ]
    },
  ]
};

export default PickSlipLineDetailsForm;
